import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { getIconCanvasFrame } from '../iconKinds'

export type IconShape = Extract<VisualShape, { type: 'icon' }>

export const isIconShape = (shape: VisualShape): shape is IconShape =>
  shape.type === 'icon'

export const isFramedIconShape = (shape: VisualShape): shape is IconShape =>
  isIconShape(shape) &&
  getIconCanvasFrame(shape.kind, shape.value) !== undefined
